import AlertType from '@mdp/mdp-ui-kit/src/components/AppAlert/AppAlert.types';
import MessageType from '@/types';

export const MIN_PASSWORD_LENGTH = 12;
export const REGEX_LOWERCASE = /[a-zäöü]/;
export const REGEX_UPPERCASE = /[A-ZÄÖÜ]/;
export const REGEX_DIGITS = /[0-9]/;
export const REGEX_SPECIAL = /[ !?@(){}[\]\\/=~$%&#*\-+.,_]/;

export const MESSAGE_ALERT_TYPE_MAP: Record<MessageType, AlertType> = {
  [MessageType.INFO]: AlertType.WARNING,
  [MessageType.ERROR]: AlertType.DANGER,
  [MessageType.SUCCESS]: AlertType.SUCCESS,
  [MessageType.WARNING]: AlertType.WARNING,
};
